export const pannellumOptions = {
    default: {
        type: 'equirectangular',
        autoLoad: true,
    },

    car_explorer: {
        autoRotate: 10,
        showControls: false,
    },

    car_interior: {},

    day_mode: {},

    night_mode: {}
};
